import { supabase } from '../../../integrations/supabase/client';

export const aiProcessingService = {
  /**
   * Procesa una imagen para obtener su descripción usando Groq Vision
   */
  async processImageDescription(imageUrl: string): Promise<string> {
    const { data, error } = await supabase.functions.invoke(
      'process-image-description',
      {
        body: { imageUrl }
      }
    );

    if (error) {
      console.error('Error procesando imagen:', error);
      throw error;
    }

    if (!data.success) {
      throw new Error(data.error || 'Error procesando imagen');
    }

    return data.description;
  },

  /**
   * Transcribe un audio usando Groq Whisper
   */
  async processAudioTranscription(audioUrl: string, fileName: string): Promise<string> {
    const { data, error } = await supabase.functions.invoke(
      'process-audio-transcription',
      {
        body: { audioUrl, fileName }
      }
    );

    if (error) {
      console.error('Error transcribiendo audio:', error);
      throw error;
    }

    if (!data.success) {
      throw new Error(data.error || 'Error transcribiendo audio');
    }

    return data.transcription;
  }
};
